/**
 * Traductions des noms de paramètres en anglais
 * Utilisé pour afficher les noms techniques en anglais dans l'interface
 */
export const parametersEn: { [key: string]: string } = {
  // Paramètres de suivi du Coran
  'targetRepeatNewHifzCount': 'New Hifz Repetition Count',
  'repeatOldHifzCount': 'Old Hifz Repetition Count',
  'repeatReviewCount': 'Review Repetition Count',
  'dailyGoal': 'Daily Goal',
  'weeklyGoal': 'Weekly Goal',
  'monthlyGoal': 'Monthly Goal',
  
  // Permission Parameters
  'allowTeacherToAddExamPoints': 'Allow Teacher to Add Exam Points',
  
  // Validation Parameters
  'checkEmailUniquenessForUsers': 'Check Email Uniqueness For Users',
  
  // Paramètres généraux
  'applicationName': 'Application Name',
  'organizationName': 'Organization Name',
  'contactEmail': 'Contact Email',
  'contactPhone': 'Contact Phone',
  'address': 'Address',
  
  // Paramètres académiques
  'academicYearStart': 'Academic Year Start',
  'academicYearEnd': 'Academic Year End',
  'maxStudentsPerClass': 'Maximum Students Per Class',
  'minAttendancePercentage': 'Minimum Attendance Percentage',
  
  // Paramètres financiers
  'monthlyFee': 'Monthly Fee',
  'annualRegistrationFee': 'Annual Registration Fee',
  'lateFeePercentage': 'Late Fee Percentage',
  
  // Paramètres de notification
  'enableEmailNotifications': 'Enable Email Notifications',
  'enableSmsNotifications': 'Enable SMS Notifications',
  'notificationLanguage': 'Notification Language',
  
  // Time zone
  'default_timezone': 'Association Time Zone',

  // Paramètres système
  'maintenanceMode': 'Maintenance Mode',
  'apiTimeout': 'API Timeout',
  'maxFileUploadSize': 'Maximum File Upload Size',
  'allowedFileTypes': 'Allowed File Types',
};

/**
 * Fonction pour obtenir la traduction d'un nom de paramètre
 * @param parameterName - Le nom technique du paramètre
 * @returns La traduction en anglais ou le nom original si non trouvé
 */
export const getParameterNameEn = (parameterName: string): string => {
  return parametersEn[parameterName] || parameterName;
};
